// Copyright 2016 Sorama B.V.

export class ServiceWorkerHandler {
    public isSupported = false;

    private registration: ServiceWorkerRegistration;

    public registerWorker(): void {
        if (navigator.serviceWorker) {
            this.isSupported = true;

            navigator.serviceWorker.register("/ServiceWorker.js", { scope: "/" }).catch((error) => {
                console.log(error);
            });

            this.requestUpdateCache();
        }
    }

    public requestUpdateCache() {
        if (navigator.serviceWorker.controller) {
            // Manually trigger an extra update event in the service worker on boot
            navigator.serviceWorker.controller.postMessage("");
        }
    }
}
